import React from 'react'
import check from "../assets/img/check.png"
import remove from "../assets/img/remove.png"
import issues from "../assets/data/component_issue.json"

const InspectionPdf = (props) => {
    let { data } = props;

    let okayPoints = [];
    let notOkayPoints = [];

    
    Object.keys(data).forEach((key, i)=>{
        if(data[key].value==="Yes"){
            okayPoints.push({
                slug:key,
                ...data[key]
            })
        } else{
            notOkayPoints.push({
                slug:key,
                ...data[key],
                issueObj:issues.find(item=>item.key===key)
            })
        }
        
    })

    console.log(okayPoints)
    console.log(notOkayPoints)

    const renderSection = (list, heading) => {
        console.log(list)
        if(!list || !list[0]) return
        return (
            <div className='issue-section'>
                <strong>{heading}:</strong>
                <ul className='issue-ul'>{list.map(item => item?<li className='issue-li'>{item}</li>:null)}</ul>
            </div>
        )
    }

    const renderItem = (listItem, i) => {
        // if(listItem.value === "Yes"){
        //     return
        // }
        if(!listItem.comment && !listItem.images.length) return null
        if (!listItem || !listItem.displayName) {
            return <div>No card!!!</div>
        }
        return (
            <div className='card-list-item'>
                <h3>{i + 1}. {listItem.displayName}</h3>
                {listItem.value === "Yes" && <div className='check'>
                    <img src={check} alt='right and okay' className='' />
                    <span>Working Fine</span>
                </div>}
                {listItem.value === "No" && <div className='cross'>
                    <img src={remove} alt='cancel and wrong not okay' className='' />
                    <span>Not Working Fine</span>
                </div>}
                {listItem.value === "No" &&  
                     <div>
                        {/* <h4> {listItem.issueObj.inspection_section}</h4> */}
                        <div className='issue-group df'>
                            {renderSection(listItem.issueObj.current_issue, "Current Issue")}
                            {renderSection(listItem.issueObj.future_issue, "Future Issue")}
                            {renderSection(listItem.issueObj.activity_need, "Activity Needed")}
                            {renderSection(listItem.issueObj.required_components, "Required Components")}
                        </div>
                    </div>
                }
                {listItem.comment ?<div className='commentTxt'>{listItem.comment}</div>:null}
                <div className='site-photos pml0'>
                    {
                        listItem.images && listItem.images.length ?
                        listItem.images.map((image, index) => <img src={URL.createObjectURL(image)} alt={listItem.displayName} />): null
                    }
                </div>

            </div>
        )
    }

    const renderPoints=(list, isFine )=>{
        return(
            <div >

                <div className={`points-title ${isFine?"":"font-red"}`}>{isFine?"Components Working Fine":"Components Not Working Fine"}</div>
                {list.map(item=>(<div className='separate-points'>
                    <img src={isFine?check:remove} alt='right and okay' className='' />
                    <span>{item.displayName}</span>
                    </div>))}
            </div>
            
        )
    }

    if (!data) {
        return <div>Nothing found!!!!</div>
    }
    return (
        <div className='inspection-main'>
           <div className='section pm10'>
            <div className='section-head'>Our Observations:</div>
            {notOkayPoints.length ?renderPoints(notOkayPoints,false):null}
            {renderPoints(okayPoints,true)}
           </div>

            {/* {Object.keys(data).map((itemSlug, i) => renderItem(data[itemSlug], i))} */}
            {okayPoints.map((item, i) => renderItem(item, i))}
            {notOkayPoints.map((item, i) => renderItem(item, i))}
            <div className='information'>
                <div><strong>* Future Issues:</strong> These issue will occur in future if the recommended activity are not done or recommended components are not replaced.</div>
                <div><strong>* Required Components:</strong> These components are mandotory to change. If components are not changed as soon as possible, the plant efficienfy will affected.</div>
                <div><strong>* Activity Needed:</strong> These activities are need to check the health of your plant in a difined period of time.</div>
            </div>

        </div>
    )
}

export default InspectionPdf